// React & Vendor Libs
const { useState } = wp.element;
import useSWR from 'swr';

// NekoUI
import { NekoInput, NekoTypo, NekoPage, NekoBlock, NekoHeader, NekoContainer, NekoSettings,
  NekoTabs, NekoTab, NekoCheckboxGroup, NekoCheckbox, NekoWrapper, NekoSelect, NekoOption,
  NekoColumn } from '@neko-ui';
import { jsonFetcher, postFetch, useHandleSWR } from '@neko-ui';

import { apiUrl } from '@app/settings';

const Settings = () => {

  const { data: swrSettings, mutate: mutateSwrSettings } = useSWR(`${apiUrl}/all_settings/`, jsonFetcher);
  const { busy: busySettings, data: settings, error: swrError } = useHandleSWR(swrSettings, {}, true);
  const [ busyAction, setBusyAction ] = useState(false);
  const busy = busySettings || busyAction;

  const obmode = settings?.mgcl_obmode;
  const parsingEngine = settings?.mgcl_parsing_engine;
  const log = settings?.mgcl_log;
  const buttonEnabled = settings?.mgcl_button_enabled;
  const buttonLabel = settings?.mgcl_button_label;

  const parsingEngineOptions = [
    { id: "none", value: "None", label: "None (Not Supported Yet)"},
    { id: "htmldomparser", value: "HtmlDomParser", label: "HtmlDomParser"},
    { id: "didom", value: "DiDom", label: "DiDom"}
  ]

  const updateOption = async (value, id) => {
    let newSettingsData = { ...swrSettings.data };
    newSettingsData[id] = value;
    mutateSwrSettings({ ...swrSettings, data: newSettingsData }, false);
    setBusyAction(true);
    try {
      await postFetch(`${apiUrl}/update_option`, { json: { name: id, value } });
    }
    catch (err) {
      alert(err.message);
    }
    finally {
      setBusyAction(false);
      mutateSwrSettings();
    }
  }

  /**
   * Settings
   */

  const jsxOBMode =
    <NekoSettings title="OB Mode">
      <NekoCheckboxGroup max="1">
        <NekoCheckbox id="mgcl_obmode" label="Check" value="1" checked={obmode} onChange={updateOption} />
      </NekoCheckboxGroup>
    </NekoSettings>;

  const jsxParsingEngine =
    <NekoSettings title="Parsing Engine">
      <NekoSelect id="mgcl_parsing_engine" onChange={updateOption}>
        {parsingEngineOptions.map(option => <NekoOption id={`mgcl_parsing_engine_${option.id}`} value={option.value} label={option.label} checked={parsingEngine === option.value} /> )}
      </NekoSelect>
    </NekoSettings>;

  const jsxLog =
    <NekoSettings title="Logs">
      <NekoCheckboxGroup max="1">
        <NekoCheckbox id="mgcl_log" label="Logs" value="1" checked={log} onChange={updateOption} />
      </NekoCheckboxGroup>
    </NekoSettings>;

  /**
   * CTA Buttons
   */
  const jsxUseButtons =
    <NekoSettings title="Use Buttons">
      <NekoCheckboxGroup max="1">
        <NekoCheckbox id="mgcl_button_enabled" label="Enabled" value="1" description="A call-to-action button will be used of a clickable image." checked={buttonEnabled} onChange={updateOption} />
      </NekoCheckboxGroup>
    </NekoSettings>;

  const jsxButtonLabel =
    <NekoSettings title="Label">
      <NekoInput id="mgcl_button_label" name="mgcl_button_label" value={buttonLabel} description="A call-to-action button will be used of a clickable image." onBlur={updateOption} />
    </NekoSettings>;

  return (
    <NekoPage nekoErrors={[ swrError ]}>

      <NekoHeader title='Gallery Custom Links | Settings' subtitle='By Jordy Meow' />

      <NekoWrapper>

        <NekoColumn full>
          <NekoContainer>
              <NekoTypo p>This plugin works out of the box, the default settings are the best for most installs. If your photos are only in the content, then you should switch the OB Mode off, that will make the process much faster. Don't hesitate to take a look at the <a href="https://meowapps.com/plugin/gallery-custom-links/">official page</a>.</NekoTypo>
          </NekoContainer>

          <NekoTabs>

            <NekoTab title='Settings'>
              <NekoWrapper>

                <NekoColumn minimal>
                  <NekoBlock busy={busy} title="Settings" className="primary">
                    {jsxOBMode}
                    {jsxParsingEngine}
                    {jsxLog}
                  </NekoBlock>
                </NekoColumn>

                <NekoColumn minimal>
                  <NekoBlock busy={busy} title="CTA Buttons" className="primary">
                    <NekoTypo p><b>Currently works with the <a href="https://wordpress.org/plugins/meow-gallery/">Meow Gallery</a> and Gutenberg Galleries.</b> In a future Pro version, support for additional galleries might be added (please contact <a href="https://meowapps.com/contact/">Meow Apps</a> for this).</NekoTypo>
                    {jsxUseButtons}
                    {!buttonEnabled ? null : jsxButtonLabel}
                  </NekoBlock>
                </NekoColumn>

              </NekoWrapper>
            </NekoTab>

          </NekoTabs>

        </NekoColumn>

      </NekoWrapper>

    </NekoPage>
  );
};

export default Settings;